module.exports = __webpack_public_path__ + "img/logo-footer.169410dc.svg";